module Common {
    //let isBannerHidden;
    let checkedIds = {};
    let checkedPages = {};
    let selectAll = false;
    let anySelectAll = false;
    export class Utilities {

        static isIe8Above() {
            let agent = navigator.userAgent.toLowerCase();
            return (/trident\/4.0/.test(agent) || /trident\/5.0/.test(agent) || /trident\/6.0/.test(agent) || /trident\/7.0/.test(agent))
                && !(/compatible;\Sissie\s7.0/.test(agent));
        }

        static menuStateButtonClick(e) {
            $(this).find('i').toggleClass('fa-angle-double-left fa-angle-double-right');
            let menuVisible = ($("#menu-toggle").find("i").hasClass("fa-angle-double-left"));
            if (menuVisible) {
                Utilities.pinMenu();
            } else {
                Utilities.unPinMenu();
            }            
        }

        static pinMenu() {
            $("#menu-toggle").find("i").removeClass("fa-angle-double-right");
            $("#menu-toggle").find("i").addClass("fa-angle-double-left");
            Utilities.expandMenu();
            Cookies.set('MenuVisible', true, { expires: 365 });
        }

        static unPinMenu() {
            $("#menu-toggle").find("i").removeClass("fa-angle-double-left");
            $("#menu-toggle").find("i").addClass("fa-angle-double-right");
            Utilities.collapseMenu();
            Cookies.set('MenuVisible', false, {expires: 365});
        }

        static expandMenu() {
            $("#wrapper").toggleClass("toggled", false);
            $("#menu").toggle(true);
        }

        static collapseMenu() {
            $("#wrapper").toggleClass("toggled", true);
            $("#menu").toggle(false);
        }

        static menuMouseEnter(e) {
            e.preventDefault();
            if ($("#sidebar-wrapper").width() < 25) {
                Utilities.expandMenu();
            }
        }

        static menuMouseLeave(e) {
            e.preventDefault();
            if ($("#menu-toggle").find("i").hasClass("fa-angle-double-right")) {
                Utilities.collapseMenu();
            }
        }

        static getLastDayOfMonth(sourceDate) {
            let beginDate = (sourceDate.getMonth() +1) + "/01/" + sourceDate.getFullYear();
            let endDate = new Date(beginDate);
            endDate.setMonth(endDate.getMonth() + 1);
            endDate.setMilliseconds(endDate.getMilliseconds() - 1);
            return endDate;
        }

        static showPopUpWindow(partialUrl) {            
            let wnd = $("#dialogWindow").data("kendoWindow");
            wnd.content("Content Loading...");            
            wnd.refresh({ url: partialUrl });            
            wnd.open();            
            wnd.center();
        }

        static clearGridSelections(e) {
            anySelectAll = false;
            selectAll = false;
            checkedIds = {};
            $("#chkSelectAll").removeAttr("checked");
        }

        static setGridSelections() {
            let grid = $("#RecipientGrid").data("kendoGrid");

            let view = grid.dataSource.view();
            for (let i = 0; i < view.length; i++) {
                let row = grid.tbody.find("tr[data-uid='" + view[i].uid + "']");
                if ((checkedIds.hasOwnProperty(view[i].id) && checkedIds[view[i].id].Checked) || selectAll
                    || (!checkedIds.hasOwnProperty(view[i].id) && anySelectAll)) {
                    row.addClass("k-state-selected");
                    let cb = row.find(".checkbox");
                    cb.prop("checked", true);
                    let rowData = { Checked: true }
                    checkedIds[view[i].id] = rowData;
                } else {
                    row.removeClass("k-state-selected");
                    let cb = row.find(".checkbox");
                    cb.prop("checked", false);
                    let rowData = { Checked: false }
                    checkedIds[view[i].id] = rowData;
                }
            }            
        }

        static selectAllRows(e) {
            let grid = $("#RecipientGrid").data("kendoGrid");
            let pageSizeDropDownList = grid.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            let pageKey = pageSizeDropDownList.text();

            let checked = e.checked;

            if (checked) {
                anySelectAll = true;
                selectAll = true;
                Utilities.setGridSelections();
            } else {
                anySelectAll = false;
                selectAll = false;
                checkedIds = {};
                grid.clearSelection();
                Utilities.setGridSelections();
            }

            checkedPages[pageKey] = checked;
        }

        static selectRow(e) {
            let grid = $("#RecipientGrid").data("kendoGrid");
            let pageSizeDropDownList = grid.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            let pageKey = pageSizeDropDownList.text();

            let checked = e.currentTarget.checked;

            $("#chkSelectAll").removeAttr("checked");
            $("#chkSelectAll").prop("checked", false);
            checkedPages[pageKey] = false;
            let row = $(this).closest("tr");

            let dataItem = grid.dataItem(row);
            let sId = dataItem["id"];
            let rowData = { Checked: checked }
            checkedIds[sId] = rowData;
            if (checked) {
                //-select the row
                row.addClass("k-state-selected");
            } else {
                //-remove selection
                row.removeClass("k-state-selected");
            }
        }
        
        static setAllSelectedItems() {
            let grid = $("#RecipientGrid").data("kendoGrid");
            grid.select(grid.tbody.find(">tr"));
            
        }

        static initSelections(grid) {
            setTimeout(function () {
                grid.table.on("click", ".checkbox", Utilities.selectRow);
                Utilities.clearGridSelections(grid);
        }, 1000);
        }

        static selectionRowChange(e) {
            let allAccounts = $("#allAccounts")
            if (allAccounts) {
                if (allAccounts.val() == "True") {
                    return
                }
            }

            let selectedDataItem = e != null ? e.sender.dataItem(e.sender.select()) : null;
            if (selectedDataItem != null && selectedDataItem["id"] != null) {
                let sId = selectedDataItem["id"];
                if (checkedIds.hasOwnProperty(sId) && checkedIds[sId].Checked) {
                    delete checkedIds[sId];
                }
                else {
                    let rowData = { Checked: true }
                    checkedIds[sId] = rowData;
                }
            }
            Utilities.setGridSelections();
        }

    }

    $(document).ready(() => {
        toastr.options.timeOut = 8000;

        //Menu is pinned by default, unpin it if previously unpinned by user.
        let isMenuVisible = 'false';
        if (Cookies)
            isMenuVisible = Cookies.get('MenuVisible');
        if (isMenuVisible === 'false') {
            Utilities.unPinMenu();
        }
        
        //Set event functions for showing/hiding menu.
        $("#menu-toggle").click(e => {
            Utilities.menuStateButtonClick(e);
        });
        $("#sidebar-wrapper").mouseleave(e => {
            Utilities.menuMouseLeave(e);
        });
        $("#sidebar-wrapper").mouseenter(e => {
            Utilities.menuMouseEnter(e);
        });
                
    });

    

}